import {useOS} from '@aboutyou/utils';
import {usePreventScroll} from 'react-aria';

export const useLockBodyScroll = ({lockScroll}: {lockScroll: boolean}) => {
  const disableLockBodyScroll = useOS() === 'android';

  usePreventScroll({isDisabled: disableLockBodyScroll ? true : !lockScroll});
};
